module.exports = __webpack_public_path__ + "static/media/xing.3e172c66.svg";